/* On Hold hover message + notify modal.
   Loaded only when settings.enable_onhold_notify is on (see theme.liquid).

   PLP cards are rendered client side by the Boost filter (bc-sf-filter.js),
   so every card listener here is delegated to document. The click handler
   runs in the CAPTURE phase so that, on held cards only, it wins over the
   legacy jQuery handler in bc-sf-filter.js that would otherwise open the
   login modal. Cards without the .onhold class are untouched. */
(function () {
  'use strict';

  if (window.__onholdNotifyInit) return;
  window.__onholdNotifyInit = true;

  var ENDPOINT = 'https://wpdiamonds.com/api/mygemma/iwish-notify/';
  var HIDE_DELAY = 150;

  var overlay, modal, formView, confirmView, form, submitBtn;
  var lastTrigger = null;
  var hideTimer = null;
  var visibleBox = null;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  document.addEventListener('DOMContentLoaded', function () {
    overlay = document.getElementById('onhold-notify-overlay');
    if (!overlay) return;
    modal = overlay.querySelector('.onhold-modal');
    formView = overlay.querySelector('.onhold-view-form');
    confirmView = overlay.querySelector('.onhold-view-confirm');
    form = document.getElementById('onhold-notify-form');
    submitBtn = form.querySelector('.onhold-submit');

    bindHover();
    bindClicks();
    bindModal();
  });

  /* ---------- hover message ---------- */

  function bindHover() {
    if (!canHover) return;

    document.addEventListener('pointerover', function (e) {
      var zone = hoverZone(e.target);
      if (!zone) return;
      clearTimeout(hideTimer);
      var box = zone.card.querySelector('.onhold-hover-box');
      if (!box) return;
      if (visibleBox && visibleBox !== box) hideBox();
      box.classList.add('is-visible');
      visibleBox = box;
    });

    document.addEventListener('pointerout', function (e) {
      if (!visibleBox) return;
      if (hoverZone(e.target) && !hoverZone(e.relatedTarget)) {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(hideBox, HIDE_DELAY);
      }
    });
  }

  /* The hover zone is the sash itself plus the open message box, never the
     rest of the card (per the client brief). */
  function hoverZone(el) {
    if (!el || !el.closest) return null;
    var target = el.closest('.product-card.onhold .onhold-banner, .product-card.onhold .onhold-hover-box');
    if (!target) return null;
    return { card: target.closest('.product-card.onhold') };
  }

  function hideBox() {
    if (visibleBox) visibleBox.classList.remove('is-visible');
    visibleBox = null;
  }

  /* ---------- open triggers ---------- */

  function bindClicks() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      /* PDP trigger (sections/main-product.liquid): a standalone link carrying
         the item details as data attributes, no product card around it. */
      var pdpTrigger = e.target.closest('[data-onhold-notify]');
      if (pdpTrigger) {
        e.preventDefault();
        e.stopPropagation();
        openModal(null, pdpTrigger);
        return;
      }

      var card = e.target.closest('.product-card.onhold');
      if (!card) return;
      var trigger = e.target.closest('.onhold-banner, .onhold-notify-open, .sold-out-wishlist-btn');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      openModal(card, trigger);
    }, true);
  }

  /* ---------- modal ---------- */

  function openModal(card, trigger) {
    lastTrigger = trigger;
    hideBox();
    if (card) populate(card); else populateFromTrigger(trigger);
    resetForm();
    formView.hidden = false;
    confirmView.hidden = true;
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (canHover) {
      var first = form.querySelector('input');
      if (first) first.focus();
    } else {
      overlay.querySelector('.onhold-modal-close').focus();
    }
  }

  function closeModal() {
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastTrigger && document.contains(lastTrigger) && lastTrigger.focus) {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function populate(card) {
    var brandEl = card.querySelector('.vendor-condition-wrap h3');
    var titleEl = card.querySelector('.plp-product-title');
    var priceEl = card.querySelector('.plp-price-wrap .money');
    var imgEl = card.querySelector('img.product-tile-image');
    var notifyBtn = card.querySelector('.sold-out-wishlist-btn');

    var title = titleEl ? titleEl.textContent.trim() : (notifyBtn ? notifyBtn.getAttribute('data-pTitle') : '');
    setText('.onhold-item-brand', brandEl ? brandEl.textContent.trim() : '');
    setText('.onhold-item-title', title);
    setText('.onhold-item-price', priceEl ? priceEl.textContent.trim() : '');

    var img = overlay.querySelector('.onhold-item-image');
    if (imgEl && imgEl.src) {
      img.src = imgEl.src;
      img.alt = title;
      img.hidden = false;
    } else {
      img.hidden = true;
    }

    form.dataset.variantId = notifyBtn ? (notifyBtn.getAttribute('data-variant') || '') : '';
    form.dataset.productId = notifyBtn ? (notifyBtn.getAttribute('data-product') || '') : '';
  }

  /* PDP: item summary comes from the trigger's data attributes. */
  function populateFromTrigger(trigger) {
    var d = trigger.dataset;
    var title = d.title || '';
    setText('.onhold-item-brand', d.brand || '');
    setText('.onhold-item-title', title);
    setText('.onhold-item-price', d.price || '');

    var img = overlay.querySelector('.onhold-item-image');
    if (d.image) {
      img.src = d.image;
      img.alt = title;
      img.hidden = false;
    } else {
      img.hidden = true;
    }

    form.dataset.variantId = d.variant || '';
    form.dataset.productId = d.product || '';
  }

  function setText(selector, value) {
    var el = overlay.querySelector(selector);
    el.textContent = value;
    el.hidden = value === '';
  }

  function bindModal() {
    overlay.querySelector('.onhold-modal-close').addEventListener('click', closeModal);
    overlay.querySelector('.onhold-continue').addEventListener('click', closeModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (overlay.hidden) {
        if (e.key === 'Escape') hideBox();
        return;
      }
      if (e.key === 'Escape') {
        closeModal();
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    });

    form.addEventListener('submit', onSubmit);

    // clear a field's error as soon as it is corrected
    form.addEventListener('input', function (e) {
      if (e.target.matches && e.target.matches('.onhold-input')) {
        setFieldError(e.target, false);
      }
    });
  }

  function trapFocus(e) {
    var focusable = modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var visible = Array.prototype.filter.call(focusable, function (el) {
      return el.offsetParent !== null;
    });
    if (!visible.length) return;
    var first = visible[0];
    var last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ---------- form ---------- */

  function resetForm() {
    form.reset();
    form.querySelectorAll('.onhold-input').forEach(function (input) {
      setFieldError(input, false);
    });
    formError(false);
    submitBtn.disabled = false;
    submitBtn.classList.remove('is-loading');
  }

  function setFieldError(input, invalid) {
    var error = document.getElementById(input.id + '-error');
    if (invalid) {
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', error.id);
    } else {
      input.removeAttribute('aria-invalid');
      if (input.id !== 'onhold-phone') input.removeAttribute('aria-describedby');
    }
    if (error) error.hidden = !invalid;
  }

  function formError(show) {
    overlay.querySelector('.onhold-form-error').hidden = !show;
  }

  function onSubmit(e) {
    e.preventDefault();
    formError(false);

    var firstNameInput = document.getElementById('onhold-first-name');
    var lastNameInput = document.getElementById('onhold-last-name');
    var emailInput = document.getElementById('onhold-email');
    var firstName = firstNameInput.value.trim();
    var lastName = lastNameInput.value.trim();
    var email = emailInput.value.trim();
    var phone = document.getElementById('onhold-phone').value.trim();

    var invalid = [];
    if (!firstName) invalid.push(firstNameInput);
    if (!lastName) invalid.push(lastNameInput);
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) invalid.push(emailInput);
    invalid.forEach(function (input) { setFieldError(input, true); });
    if (invalid.length) {
      invalid[0].focus();
      return;
    }

    submitBtn.disabled = true;
    submitBtn.classList.add('is-loading');

    var params = new URLSearchParams();
    params.append('id', form.dataset.variantId || '');
    params.append('product', form.dataset.productId || '');
    params.append('customer', (window.ShopifyAnalytics && ShopifyAnalytics.meta.page.customerId) || '');
    params.append('onhold', 'true');
    /* legacy combined "name" kept so the currently deployed endpoint still gets a name */
    params.append('name', (firstName + ' ' + lastName).trim());
    params.append('first_name', firstName);
    params.append('last_name', lastName);
    params.append('email', email);
    params.append('phone', phone);

    /* The endpoint sends no CORS headers, so the response is opaque; the
       legacy notify flow is fire and forget the same way. no-cors still
       delivers the POST; only a network failure rejects. */
    fetch(ENDPOINT, { method: 'POST', mode: 'no-cors', body: params })
      .then(showConfirm)
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
        formError(true);
      });
  }

  function showConfirm() {
    formView.hidden = true;
    confirmView.hidden = false;
    confirmView.querySelector('.onhold-confirm-title').focus();
  }
})();
